import { Col } from 'components/Col';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { useContext, useEffect, useMemo } from 'react';
import { getOptionsFromParams } from 'utils/DropdownUtils';
import languageValues from 'utils/LanguageUtils';
import { getFlgInfantil } from 'utils/projeto';

const language = languageValues.inputs.idEtapasEnsino;
export default function EtapasEducacao() {
  const { state, dispatch, validator, loadEtapasEducacao } =
    useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'idEtapasEnsino',
        etapa: EtapaProjeto.infosIniciais,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  useEffect(() => {
    loadEtapasEducacao();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = useMemo(() => {
    return state.options.etapasEducacao.options
      ? getOptionsFromParams(state.options.etapasEducacao.options, 'id', (i) =>
          i.nome.toUpperCase()
        )
      : [];
  }, [state.options.etapasEducacao.options]);

  return (
    <Row>
      <Col>
        <NewAutoCompleteField
          label={language.label}
          placeholder={language.placeholder}
          loading={state.options.etapasEducacao.loading}
          loadingMessage={language.loading}
          options={options}
          value={state.projeto.idEtapasEnsino ?? []}
          multiple
          onChange={(option: { value: number; label: string }[]) => {
            const flgInfantil = getFlgInfantil(
              option?.map((o) => o.value) ?? []
            );

            dispatch({
              type: 'setProjeto',
              payload: {
                idEtapasEnsino: option ? option.map((o) => o.value) : [],
                flgInfantil,
              },
            });
          }}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
